import { z } from "zod";

export const signalsViewSchema = z.enum(["board", "table", "swipe"]);
export const userPreferencesSchema = z.object({
  signalsView: signalsViewSchema,
});
export type UserPreferences = z.infer<typeof userPreferencesSchema>;
export const defaultUserPreferences: UserPreferences = {
  signalsView: "board",
};
// Patches have no defaults: omitted keys must never reset an existing choice.
export const userPreferencesPatchSchema = userPreferencesSchema.partial().strict();
export type UserPreferencesPatch = z.infer<typeof userPreferencesPatchSchema>;
export function resolveUserPreferences(stored: Partial<UserPreferences>): UserPreferences {
  return userPreferencesSchema.parse({ ...defaultUserPreferences, ...stored });
}
